import { AddressDetailResponse } from '@/types/service-response'
import { AddressEmployee } from '@/model/addresses/AddressEmployee'

export class AddressDetail {
  public constructor (
    readonly language: number | undefined,
    readonly addressNumber: string,
    readonly sorting: string,
    readonly name: string,
    readonly land: number | undefined,
    readonly addressGroup: number | undefined,
    readonly selectedSalutation: number | undefined,
    readonly selectedTitle: number | undefined,
    readonly firstName: string,
    readonly addition: string,
    readonly street: string,
    readonly houseNumber: string,
    readonly pobox: string,
    readonly postcode: string,
    readonly city: string,
    readonly region: string,
    readonly businessPhone: string,
    readonly businessFax: string,
    readonly privatePhone: string,
    readonly businessMobile: string,
    readonly businessMail: string,
    readonly privateMail: string,
    readonly webPage: string,
    readonly privateMobile: string,
    readonly description: string,
    readonly id: number | undefined,
    readonly active: boolean,
    readonly isPrivateAddress: boolean,
    readonly color: string,
    readonly geoLat: number | undefined,
    readonly geoLon: number | undefined,
    readonly addressEmployee: AddressEmployee[] | undefined
  ) {}

  static createFromResponse (responseData: AddressDetailResponse): AddressDetail {
    let addressEmployeeData: AddressEmployee[] | undefined = responseData.Sachbearbeiter ?  AddressEmployee.createFromResponse(responseData.Sachbearbeiter): undefined
    return new AddressDetail(
      responseData.Sprache ? responseData.Sprache : undefined,
      responseData.AdressNummer,
      responseData.Sortierung,
      responseData.Name,
      responseData.Land ? responseData.Land : undefined,
      responseData.AdressGruppe,
      responseData.Anrede ? responseData.Anrede : undefined,
      responseData.Titel ? responseData.Titel : undefined,
      responseData.Vorname,
      responseData.Zusatz,
      responseData.Strasse,
      responseData.Hausnummer,
      responseData.Postfach,
      responseData.PLZ,
      responseData.Ort,
      responseData.Region,
      responseData.Telefongeschaeftlich,
      responseData.Faxgeschaeftlich,
      responseData.Telefonprivat,
      responseData.Handygeschaeftlich,
      responseData.Mailgeschaeftlich,
      responseData.Mailprivat,
      responseData.Homepage,
      responseData.Handyprivat,
      responseData.Beschreibung,
      responseData.ID ? responseData.ID : undefined,
      responseData.Aktiv,
      responseData.PrivatAdresse,
      responseData.Farbe,
      responseData.GeoLAT ? responseData.GeoLAT : undefined,
      responseData.GeoLON ? responseData.GeoLON : undefined,
      addressEmployeeData
    )
  }

  static createEmpty (): AddressDetail {
    const color: string | null = localStorage.getItem('primaryColor')
    return new AddressDetail(
      undefined,
      '',
      '',
      '',
      undefined,
      undefined,
      undefined,
      undefined,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      undefined,
      true,
      true,
      color ? color : '#000',
      undefined,
      undefined,
      undefined
    )
  }
}
